import { Alert, Box, Button, Dialog, DialogContent, DialogTitle, Grid2, IconButton, TextareaAutosize } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import CardsRead from "./cards-read";
import { useTranslation } from "react-i18next";
import ReactGA from 'react-ga4'
import { changeQuestionAct, getReadingAsync, revealCardsAct, showModalTarotAct } from "../domain/slice/tarot-slice";
import RevealedCards from "./cards-revealed";
import type { CardType } from "../domain/data/models/card-type";
import React from "react";
import LoadingReading from "./loading-reading";
import { Close } from "@mui/icons-material";
export default function ModalTarot() {
  const { t, i18n } = useTranslation()
  const dispatch = useAppDispatch()
  const [error, setError] = React.useState<boolean>(false)
  const { showModal, revealedCards, pickedCardsIndex, cards, question, loading, readingResult } = useAppSelector((state) => state.TarotSlice)
  const revealCards = () => {
    if(question.length <= 10) {
      setError(true);
    } else {
      ReactGA.event({
        category: 'Tarot',
        action: 'Reveal Cards',
        label: 'web'
      })
      setError(false);
      dispatch(revealCardsAct())
    }
  }
  const getReading = () => {
    const cardsPicked: string[] = pickedCardsIndex.map((card, index) => {
      const c: CardType = cards[card.index*(card.row + 1)];
      return t(`card.titles.${c.title}`)
    })
    const language = i18n.language === "en" ? "english" : "spanish"
    console.log({cardsPicked, question, language});
    if(question.length <= 10) {
      setError(true);
    } else {
      ReactGA.event({
        category: 'Tarot',
        action: 'Get Reading',
        label: 'web'
      })
      setError(false);
      dispatch(getReadingAsync({
        cards: cardsPicked,
        question,
        language,
      }))
    }
  }

  const closeModal = () => {
    ReactGA.event({
      category: 'Tarot',
      action: 'Close Modal',
      label: 'web'
    })
    dispatch(showModalTarotAct(false))
  }

  return (
    <>  
      {/* <LoadingIndicator open={loading}/> */}
      <Dialog open={showModal} sx={{
        '.MuiPaper-root': {
          margin: '5px'
        }
      }}>
        <DialogTitle textAlign={'center'}> {t('modal_tarot_title')} <IconButton onClick={closeModal}> <Close/> </IconButton> </DialogTitle>
        <DialogContent style={{minWidth: 380}}>
          {!loading && <Box>
            <Grid2 container marginBottom={2}>
              <Grid2 size={12} >
                <TextareaAutosize  disabled={readingResult !== undefined || revealedCards} value={question} placeholder="Escribe tu pregunta" style={{marginBottom: 2, width: '100%'}} minRows={3} onChange={(e) => dispatch(changeQuestionAct(e.target.value))}/>
                {error && <Alert variant="outlined" color="error"> {t('error_question')} </Alert>}
              </Grid2>
            </Grid2>
            {!revealedCards && <CardsRead />}
            {revealedCards && <RevealedCards />}

            <Grid2 container marginTop={1}>
              <Grid2 size={12} marginTop={1} textAlign='center'>
                {!revealedCards && <Button disabled={pickedCardsIndex.length !== 3 || question.length <= 10} onClick={revealCards} variant="contained" size="large" color="secondary">{t('modal_tarot_reveal_card')}</Button>}
                {revealedCards && readingResult === undefined && <Button disabled={pickedCardsIndex.length !== 3 || loading} onClick={getReading} variant="contained" size="large" color="secondary">{t('modal_tarot_get_reading')}</Button>}
              </Grid2>
            </Grid2>
          </Box>}
          {loading && <LoadingReading/>}  
        </DialogContent>
      </Dialog>
    </>
  )
}